import template from './insert-document.html';
import controller from './insert-document.controller';
import './insert-document.scss';

export default {
	template,
	controller,
	controllerAs: '$ctrl',
};
